import { render, staticRenderFns } from "./Widget.vue?vue&type=template&id=f240e8f2&scoped=true&"
import script from "./Widget.vue?vue&type=script&lang=ts&"
export * from "./Widget.vue?vue&type=script&lang=ts&"
import style0 from "./Widget.vue?vue&type=style&index=0&id=f240e8f2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f240e8f2",
  null
  
)

export default component.exports